import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getMatchAccaConfig() {
    return {
        palette: {
            [PALETTE_IDS.MATCH_ACCA]: {},
            [PALETTE_IDS.MARKET_INSTRUCTIONS]: {
                MARKET_INSTRUCTIONS_CONTENT_BG: COLOR.BRAND.FOREGROUND4,
                MARKET_INSTRUCTIONS_BET_BUILDER_ICON_COLOR: COLOR.BRAND.ACCENT2,
            },
            [PALETTE_IDS.MATCH_ACCA_SLIP]: {
                MATCH_ACCA_SLIP_BG: COLOR.BRAND.BACKGROUND1,
                MATCH_ACCA_SLIP_SELECTION_BG: COLOR.BRAND.FOREGROUND4,
                MATCH_ACCA_SLIP_ADD_TO_BETSLIP_BORDER_COLOR: COLOR.BRAND.ACCENT2,

                MATCH_ACCA_SLIP_SELECTION_SEPARATOR_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
                MATCH_ACCA_SLIP_ONBOARDING_SELECTION_SEPARATOR_ICON_COLOR: COLOR.BRAND.FOREGROUND3,
                MATCH_ACCA_SLIP_ONBOARDING_TITLE_TEXT: {
                    fontWeight: FONT.WEIGHT_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },

                MATCH_ACCA_SLIP_ONBOARDING_SELECTION_NAME_TEXT: {
                    fontWeight: FONT.WEIGHT_BOLD,
                    color: COLOR.BRAND.FOREGROUND2,
                },
            },
        },
    };
}
